import { useQuery } from '@tanstack/react-query';
import { fetchDefaultShipmentPickupLocation } from '../data-provider/default-shipment-address';

export const useGetDefaultShipmentPickupLocation = () => {
  return useQuery({
    queryKey: ['default-shipment-pickup-location'],
    queryFn: () => fetchDefaultShipmentPickupLocation(),
  });
};
